module.exports = __webpack_public_path__ + "static/media/icon_dataset.c21124d8.svg";